module.exports = __webpack_public_path__ + "img/home_logo_white.7c184a36.png";